import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import useComparisonValues from '../../../hooks/useComparisonValues';

import formatNumber from '../../../../../helpers/formatNumber';

import styles from './AmountField.module.scss';

function AmountField({ name, value }: { name: string; value: number }) {
  const {
    i18n: { language },
  } = useTranslation();
  const path = `/${name}`;

  const { oldValue, newValue } = useComparisonValues({ path, value });

  if (Number(oldValue) !== Number(newValue)) {
    return (
      <div className="flex flex-column">
        <span className={cn(styles.amount, styles.newAmount)}>
          {formatNumber({ value: newValue as number, locale: language })}
        </span>
        <span className={styles.oldAmount}>{formatNumber({ value: oldValue as number, locale: language })}</span>
      </div>
    );
  }

  return <span className={styles.amount}>{formatNumber({ value: newValue as number, locale: language })}</span>;
}

export default AmountField;
